import React, { useContext, FC, ReactNode } from 'react';

import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

import { AuthContext, AuthStatus } from 'src/contexts/authContext';
import { isMobile } from 'react-device-detect';

interface AuthGuardProps {
  children?: ReactNode;
}

const AuthGuard: FC<AuthGuardProps> = ({ children }) => {
  const { authStatus } = useContext(AuthContext);

  if (isMobile) {
    return <Redirect to="/error" />;
  }

  if (authStatus !== AuthStatus.SignedIn) {
    return <Redirect to="/login" />;
  }

  return <>{children}</>;
};

AuthGuard.propTypes = {
  children: PropTypes.node
};

export default AuthGuard;
